import { modalBibliographySearchResultContentStore } from '@/store'
import { ModalBibliographySearchResultContentStoreInterface } from '@/store/ModalBibliographySearchResultContentStore'

export class ModalBibliographySearchResultContentService {
  public open(params: ModalBibliographySearchResultContentStoreInterface) {
    modalBibliographySearchResultContentStore.open(params)
  }

  public close() {
    modalBibliographySearchResultContentStore.close()
  }
}
